import { animate, style, transition, trigger } from '@angular/animations';

export const fadeAnimation = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate(100)]),
  transition(':leave', animate(100, style({ opacity: 0 }))),
]);
